import { debugLogReducer } from "../helpers/debugHelper";
import { types } from "../types/types";

const initialState = {

  innovations: [],

  innovation: {},
  innovationSaved: {},
  innovationSelected: {},

  innovationsP: [],
  totalItemsInnovationP: 0,
  totalPagesInnovationP: 0,
  currentPageInnovationP: 0,

  innovationsS: [],
  totalItemsInnovationS: 0,
  totalPagesInnovationS: 0,
  currentPageInnovationS: 0,

  searchTextState: "",

  moreThanOneIsSelected: false,
  numberInnovationSelected: 0,

  isLoadingInnovations: false
};

const countSelected = (list) => list.filter(item => item.isSelected).length;

export const innovationReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.INNOVATION_START_REGISTER_ADMIN:

      return {
        ...state,
        innovationSaved: action.payload,
      };

    case types.INNOVATION_UPDATE:
      if (state.innovationsS.length > 0) {
        return {
          ...state,
          innovationsS: state.innovationsS.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
          innovationsP: state.innovationsP.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
        };
      } else {
        return {
          ...state,
          innovationsP: state.innovationsP.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
        };
      }

    case types.INNOVATION_DELETE:
      if (state.innovationsS.length > 0) {
        return {
          ...state,
          innovationsS: state.innovationsS.filter((usr) => usr.id !== action.payload),
          innovationsP: state.innovationsP.filter((usr) => usr.id !== action.payload),
          innovationSelected: {},
        };
      } else {
        return {
          ...state,
          innovationsP: state.innovationsP.filter((usr) => usr.id !== action.payload),
          innovationSelected: {},
        };
      }

    case types.INNOVATION_START_LOADING_PAGINATED:
      return {
        ...state,
        innovationsP: action.payload.innovationsP,
        totalItemsInnovationP: action.payload.totalItems,
        totalPagesInnovationP: action.payload.totalPages,
        currentPageInnovationP: action.payload.currentPage,
      };

    case types.INNOVATION_START_LOADING_INNOVATION_PAGINATED:

      return {
        ...state,
        innovationsS: action.payload.innovationsP,
        totalItemsInnovationS: action.payload.totalItems,
        totalPagesInnovationS: action.payload.totalPages,
        currentPageInnovationS: action.payload.currentPage,
      };

    case types.INNOVATION_START_SEARCH_PAGINATED:
      return {
        ...state,
        innovationsS: action.payload.innovationsP,
        totalItemsInnovationS: action.payload.totalItems,
        totalPagesInnovationS: action.payload.totalPages,
        currentPageInnovationS: action.payload.currentPage,
      };

    case types.INNOVATION_SELECT:
      return {
        ...state,
        innovationSelected: action.payload,
      };

    case types.INNOVATION_CLEAN_SEARCH_PAGINATED:
      return {
        ...state,
        innovationsS: [],
        totalItemsInnovationS: 0,
        totalPagesInnovationS: 0,
        currentPageInnovationS: 0,

        numberInnovationSelected: 0
      };

    case types.INNOVATION_CLEAN_PAGINATED:
      return {
        ...state,
        innovationsP: [],
        totalItemsInnovationP: 0,
        totalPagesInnovationP: 0,
        currentPageInnovationP: 0,

      };

    case types.INNOVATION_SET_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: action.payload,
      };

    case types.INNOVATION_CLEAN_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: "",
      };

    case types.INNOVATION_CLEAN_SAVED:
      return {
        ...state,
        innovationSaved: {},
      };

    /*
  case types.INNOVATION_LIST_UPDATE_SELECTED:
    
    if (state.innovationsS.length > 0) {
      return {
        ...state,
        innovationsS: state.innovationsS.map((usr) => (usr.id === action.payload ? { ...usr, isSelected: !usr.isSelected } : usr)),

      };
    }
    break;
    */
    case types.INNOVATION_LIST_UPDATE_SELECTED: {
      const id = action.payload;
      const currentSelectedCount = countSelected(state.innovationsS);
      const targetItem = state.innovationsS.find(item => item.id === id);

      // Si va a seleccionar uno nuevo y ya hay 9, no hacer nada
      if (!targetItem.isSelected && currentSelectedCount >= 9) return state;

      const newInnovations = state.innovationsS.map(item =>
        item.id === id ? { ...item, isSelected: !item.isSelected } : item
      );

      const newCount = countSelected(newInnovations);

      return {
        ...state,
        innovationsS: newInnovations,
        numberInnovationSelected: newCount,
        moreThanOneIsSelected: newCount > 1
      };
    }

    // Selección masiva (Primeros 9 o todos si hay menos)
    case types.INNOVATION_SELECT_ALL_LIMIT: {
      const newInnovations = state.innovationsS.map((item, index) => ({
        ...item,
        isSelected: index < 9 // Selecciona solo los primeros 9
      }));

      const newCount = countSelected(newInnovations);

      return {
        ...state,
        innovationsS: newInnovations,
        numberInnovationSelected: newCount,
        moreThanOneIsSelected: newCount > 1
      };
    }

    // Limpiar todo
    case types.INNOVATION_CLEAN_ALL_SELECTED: {
      return {
        ...state,
        innovationsS: state.innovationsS.map(item => ({ ...item, isSelected: false })),
        numberInnovationSelected: 0,
        moreThanOneIsSelected: false
      };
    }

    //Clean Without list
    case types.INNOVATION_CLEAN_ALL_WITHOUT_LIST: {
      return {
        ...state,
        numberInnovationSelected: 0,
        moreThanOneIsSelected: false
      };
    }

    case types.INNOVATION_GET_MORE_THAN_ONE_SELECTED:

      debugLogReducer(":: INNOVATION_GET_MORE_THAN_ONE_SELECTED");

      if (state.innovationsS.length > 0) {
        return {
          ...state,
          moreThanOneIsSelected: getMoreThanOneIsSelected(state)
        };
      }
      break;

    case types.INNOVATION_LIST_SET_NUMBER_SELECTED:

      debugLogReducer(":: INNOVATION_LIST_SET_NUMBER_SELECTED");

      if (state.innovationsS.length > 0) {
        return {
          ...state,
          numberInnovationSelected: action.payload
        };
      }
      break;

    case types.INNOVATION_CLEAN_SEARCH_INFORMATION:

      debugLogReducer(":: INNOVATION_CLEAN_SEARCH_INFORMATION");

      return {
        ...state,
        numberInnovationSelected: 0
      };

    case types.INNOVATION_IS_LOADING:

      return {
        ...state,
        isLoadingInnovations: true
      };

    case types.INNOVATION_IS_LOADING_FINISH:

      return {
        ...state,
        isLoadingInnovations: false
      };

    default:
      return state;
  }
};

const getMoreThanOneIsSelected = (state) => {

  debugLogReducer(":: getMoreThanOneIsSelected");

  let flagMoreThanOne = false;
  let counterFlagMoreThanOneIsSelected = 0;

  if (state.innovationsS.length > 0) {
    state.innovationsS.forEach(element => {

      if (element.isSelected) {
        counterFlagMoreThanOneIsSelected = counterFlagMoreThanOneIsSelected + 1;
      }
    });
  }

  if (counterFlagMoreThanOneIsSelected > 1) {
    flagMoreThanOne = true;
  }

  return flagMoreThanOne;
}